import { useMemo } from 'react';
import { Option } from '@/containers/LostHours/types.ts';
import { utilizeEmployeeListOptions } from '@/containers/LostHours/utils.ts';
import { useLostHoursEmployeesListQuery } from '@/api/methods/useLostHoursEmployeesListQuery.ts';

export const useEmployeeListOptions = () => {
  const { data: employees } = useLostHoursEmployeesListQuery();

  return useMemo(
    (): Option[] => utilizeEmployeeListOptions(employees),
    [employees]
  );
};
